import React, { useState, useEffect } from "react";

import Dialog from "./Dialog";
import { useApi } from "../../../../api";
import { setFieldErrorsFromResponse } from "../../../../utils/formErrors";
import MaintenanceForm from "../Form/MaintenanceForm";
import useI18nSnackbar from "../../../../hooks/useI18nSnackbar";
import { format } from "date-fns";

const EditContainer = ({ maintenanceId, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();
  const [isLoading, setLoading] = useState(true);
  const [record, setRecord] = useState(null);

  useEffect(() => {
    setLoading(true);

    api
      .get(`/v2/maintenance/${maintenanceId}`)
      .then(response => {
        setRecord(response.data);
        setLoading(false);
      })
      .catch(e => {
        if (e.response && e.response.status === 404) {
          onClose();
        }
      });
  }, [api, maintenanceId, onClose]);

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    const params = {
      title: values.title,
      description: values.description,
      priority: values.priority,
      technician: values.technician,
      maintenanceInterval: values.maintenanceInterval,
      maintenanceAt: values.maintenanceAt
        ? format(new Date(values.maintenanceAt), "yyyy-MM-dd")
        : null,
      status: values.status
    };

    api
      .put(`/v2/maintenance/${record.id}`, params)
      .then(() => {
        enqueueSnackbar("devices.maintenance.responses.updated", {
          variant: "success"
        });

        onClose(true);
      })
      .catch(e => {
        if (!e.response) {
          return;
        }

        setSubmitting(false);
        setFieldErrorsFromResponse(e.response, setFieldError);
      });
  };

  if (isLoading) {
    return null;
  }

  const values = {
    title: record.title,
    description: record.description || "",
    priority: record.priority,
    technician: record.technician || "",
    maintenanceInterval: record.maintenanceInterval,
    maintenanceAt: new Date(record.maintenanceAt),
    status: record.status
  };

  const handleCancel = () => onClose();

  return (
    <Dialog onClose={handleCancel}>
      <MaintenanceForm
        values={values}
        isEdit
        onClose={handleCancel}
        onSubmit={handleSubmit}
      />
    </Dialog>
  );
};

export default EditContainer;
